import Utils, {
  Storage,
  getStorageItem,
  getStorageKey,
  timeslotsEqual,
  navigate,
  isWeb,
} from "./helpers/utils";

import APPCONFIG from "./config/AppConfig";
import { Notifications } from "./helpers/notifications/notifications";
import moment from "moment";
import tracking from "./services/analytics/tracking";
import PageLogin from "./pages/login/login";
import NativeHelper from "./pages/v3/native/NativeHelper";

let notifications = new Notifications();

import { Buffer } from "buffer";
import appPages from "./appPages";
const pako = require("pako");

const THROTTLE_BACKGROUND_REFRESH_MS = 500;
const THROTTLE_ACTIVATE_REFRESH_MS = 60 * 1000;

const SERIALIZE_REPORTS = false;

const STATE_NOT_SERIALIZED = [
  "activities",
  "sets",
  "tags",
  "reflection",
  "reflection_insights",
  "timeslots_data",
  "timeslots",
  "timeslots1",
  "timeslots2",
  "users",
  "screenArgs",
];

const STATE_NOT_SERIALIZED_WEB = [
  "elements",
  "timeslots",
  "sequences",
  "probable_times",
  "calendar_prob",
  "routines",
  "template_data",
  "cards_v2",
];

const NAVIGATION_MAPPING = {
  home: "feed",
  home_card: "feed",
  reflection: appPages.reflectionPage,
  sets_reflection: appPages.reflectionPage,
  resolution: appPages.resolutionPage,
  resolution_gems: "gems",
  resolution_detail: "goal",
  activities: appPages.elementsPage,
  edit_journal: appPages.trackDetail,
  journal: appPages.trackHome,
  edit_activity: "element",
  edit_tag: "tag",
  edit_set: "set",
  tag_activities: "tags",
  sets_reflection_detail: appPages.reflectionDetailPage,
  onboarding_template: "average_week",
};

const RN_PAGES = {
  activities: "activities",
  appointment: "appointment",
  average_template: "average_template",
  edit_activity: "edit_activity",
  edit_journal: "edit_journal",
  edit_set: "edit_set",
  edit_tag: "edit_tag",
  elements: "elements",
  elements_v2: "elements_v2",
  edit_element: "edit_element",
  archive_elements: "archive_elements",
  enabled_users: "enabled_users",
  feed: "home_card",
  home_card: "home_card",
  home: "home_card",
  impersonate: "impersonate",
  integrations: "integrations",
  invite_friends: "invite_friends",
  journal: "journal",
  knowledge_base: "knowledge_base",
  more: "more",
  onboarding_img: "onboarding",
  onboarding_info: "onboarding_info",
  onboarding_template: "onboarding_template",
  profile: "profile",
  resolution_detail: "resolution_detail",
  resolution_gems: "resolution_gems",
  resolution: appPages.resolutionPage,
  sets_reflection_detail: "sets_reflection_detail",
  sets_reflection: "sets_reflection",
  settings: "settings",
  survey: "survey",
  tag_activities: "tag_activities",
  tags: "tags",
  testing: "testing",
  track_tutorial: "track_tutorial",
};

// Segment setup
if (APPCONFIG.ENABLE_SEGMENT) tracking
  .setup(APPCONFIG.SEGMENT_KEY, {
    // Record screen views automatically!
    recordScreenViews: true,
    // Record certain application events automatically!
    trackAppLifecycleEvents: true,
  })
  .then(
    () => {
      console.log("[segment] Succesfully installed");
    },
    (e) => {
      console.log("[segment] Err", e);
    },
  );

const getPredictedActivitiesFromIndex = (timeslots, index) => {
  let out;

  while (!out && index < timeslots.length) {
    index++;
    if (timeslots[index]) {
      out = timeslots[index].predicted_activities;
    }
  }

  return out;
};

class Controller {
  constructor(services, offlineEnabled, onPageChange) {
    this.services = services;
    this.apiService = services.apiService;

    this.state = this.emptyState();
    this.offlineEnabled = offlineEnabled;

    this.tracking = tracking;
    this.lastKnownState = null;
    this.stateToSave = null;

    this.restoreState();

    this.onPageChange = onPageChange;

    this.pendingAction = null;
    this.pendingActionStart = null;
    this.actionStartLog = {};
    this.actionLog = [];

    this.lastOnline = null;
    this.lastActionsCount = 0;
    this.cardActionCount = 0;
    this.lastOnlineRetry = +new Date();
    this.retryOnlineIntervalMs = 30000;
    this.retryActionsCount = 10;
    this.retryActionEvenIfPendingMs = 60000;
    this.lastActivateRefresh = 0;

    this.lastUploadedAvatar = null;

    this.registeredCurrentPageRefresh = null;
    this.lastBackgroundRefresh = null;

    this.lastCalendarItemsChecksum = null;
    this.lastHealthItemsChecksum = null;

    this.lastReloadTimeMs = null;

    this.cachedVariables = {}; //TODO: smarter LIFO map with limited storage
    this.cachedReferences = {};

    this.definedPages = [];
    this.isTransient = [
      "welcome",
      "login",
      "loginerr",
      "error",
      "offline",
      "confirm",
      "sleep",
    ]; //to move as property per page
    this.monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    this.privacyLevel = null;

    this.applyUserSettings();

    // TUTORIALS
    this.initTutorials();
  }

  applyUserSettings() {
    if (this.state.settings != null) {
      const s = this.state.settings;
      if (s.privacy_level != null) this.privacyLevel = s.privacy_level;
      notifications.scheduleNotifications(
        !!s.enable_notifications,
        s.notifications,
      );
    }
  }

  onRegister(token) {
    console.log(token);
    this.setState({ registerToken: token.token, gcmRegistered: true });
  }

  onNotif(notif) {
    notifications.scheduleNotifications(true, notif);
  }

  isChunkPredictions() {
    return this.state?.settings?.chunk_predictions;
  }

  setDefinedPages(definedPages) {
    this.definedPages = definedPages;
  }

  emptyState(installId = null) {
    const newState = {
      installId: installId,

      currentScreen: "welcome",
      selectedPage: "home",
      prevScreen: "welcome",
      screenArgs: null,

      lastUpdateTime: null,

      lastManaTime: null,
      settings: null,
      stats: null,

      currentUser: null,
      accessToken: null,
      picture: null,

      cards: null,
      cardsTemplates: null,
      svgTemplates: null,
      users: null,

      error: null,
      error_element: null,

      uploadData: null,
      offlineActions: null,

      lastCalendarQuery: null,
      calendarItems: null,
      calendarItemsChecksum: null,
      calendarLoginShown: false,

      sequences: null,
      probable_times: null,
      rules: null,
      calendar_prob: null,
      routines: null,
      reflection_root: null,
      sent_reports: null,
      received_reports: null,
      received_aggregated_reports: null,
      teams: null,

      reflection: null,
      reflection_insights : null,
      resolutions: null,

      activities: null,
      elements: null,
      archived_elements: null,
      goal_presets: null,
      timeslots: null,

      snoozed_cards: null,

      lastHealthQuery: null,
      healthItems: null,
      healthItemsChecksum: null,

      pageHistory: null,

      impersonate: null,
    };
    if (this.state) Object.keys(this.state).forEach((k) => {
      if (k.startsWith("timeslots_data")) {
        newState[k] = null;
      }
    })
    return newState;
  }

  resetState(keepCredentials, impersonate = null) {
    console.log("Reset state");
    const state = this.emptyState(this.state.installId);
    if (keepCredentials != null && keepCredentials) {
      state.currentUser = this.state.currentUser;
      state.accessToken = this.state.accessToken;
      state.picture = this.state.picture;
      state.impersonate = impersonate;
    }
    this.setState(state);
  }

  restoreState() {
    const setState = this.setState.bind(this);
    Storage.getItem("state")
      .then((state) => {
        console.log("Read stored state.");
        //console.log("Read stored state " + state);
        if (state == null || state === "null") {
          state = this.emptyState();
          console.log("Using empty state");
        } else {
          try {
            const data = pako.inflate(new Buffer(state, "base64"), {
              to: "string",
            });
            state = JSON.parse(data);
          } catch (e) {
            state = JSON.parse(state); //backward compat
          }
        }

        if (state.installId == null) {
          const uuidv4 = require("uuid/v4");
          state.installId = uuidv4();
        }

        if (
          state.currentScreen === "error" ||
          state.currentScreen === "loginerr" ||
          state.currentScreen === "terms" ||
          state.currentScreen === appPages.onboardingInfoPage ||
          state.currentScreen === "offline"
        ) {
          state.currentScreen = "home";
        }

        const showUI =
          (state.termsAgreed && state.tutorialDone) ||
          state.impersonate != null;
        if (state.currentUser == null || !showUI) {
          state.currentScreen = "welcome";
        }

        const termsAgreed =
          state.settings != null && state.settings.terms_agreed;
        if (
          state.settings != null &&
          !termsAgreed &&
          state.impersonate == null &&
          !["login", "welcome", "error"].includes(state.currentScreen)
        ) {
          state.currentScreen = appPages.onboardingInfoPage;
        }

        console.log(
          "Current stored page " +
            (state != null ? state.currentScreen : "null"),
        );
        console.log(
          "Stored user " + (state != null ? state.currentUser : "null"),
        );

        this.setState(state);
      })
      .catch((err) => {
        console.log(err);
        console.log("Failed reading stored state, using empty");
        const state = this.emptyState();

        if (state.installId == null) {
          const uuidv4 = require("uuid/v4");
          state.installId = uuidv4();
        }

        this.setState(state);
      });
  }

  setPurchases(purchases) {
    //TODO: server side receipt validation
    this.setState({
      purchases: purchases,
    });
  }

  setPayedSubscriptions(subscriptions) {
    //TODO: server side receipt validation
    this.setState({
      payedSubscriptions: subscriptions,
    });
  }

  getPurchase() {
    if (this.state.purchases != null && this.state.purchases.length > 0) {
      //TODO: rewrite when/if multiple subscriptions possible
      const purchase = this.state.purchases[0];
      var result = {
        productId: purchase.productId,
        transactionDate: purchase.transactionDate,
      };
      this.state.payedSubscriptions.forEach((s) => {
        if (s.productId === result.productId) result = Object.assign(result, s);
      });
      return result;
    } else {
      return null;
    }
  }

  async saveState(timeout = 5000) {
    //throttle
    const encoded = JSON.stringify(this.state, (key, value) =>
      STATE_NOT_SERIALIZED.includes(key) ||
      key.startsWith("timeslots_data") ||
      (!SERIALIZE_REPORTS && key.startsWith("report:")) ||
      (isWeb && STATE_NOT_SERIALIZED_WEB.includes(key))
        ? undefined
        : value,
    );
    return new Promise(function (resolve, reject) {
      if (this.lastKnownState !== encoded) {
        this.stateToSave = encoded;

        setTimeout(() => {
          const newEncodedState = this.stateToSave;
          if (this.lastKnownState !== newEncodedState) {
            this.lastKnownState = newEncodedState;

            const data =
              APPCONFIG.PACK_STATE && isWeb
                ? new Buffer(pako.deflate(newEncodedState), "base64").toString(
                    "base64",
                  )
                : newEncodedState;
            return Storage.setItem("state", data).then(resolve);
          }
        }, timeout);
      } else {
        resolve();
      }
    });
  }

  isAuth() {
    return this.state.accessToken != null; //TODO: check token expiration
  }

  logout() {
    console.log("Triggered logout");
    if (window.embeddedLogin && window.embeddedLogin.logout && window.embeddedLogin.login) {
      window.embeddedLogin.logout();
      console.log("Clear state");
      this.state = this.emptyState(this.state.installId);
      this.setApiUser();
      this.saveState().then(() => {
        if (this.updateState != null) this.updateState();
        //window.embeddedLogin.login();
      });
      navigate(this, "welcome", null, null);
    } else {
      const loginScreen = new PageLogin({controller: this});
      if (loginScreen != null)
        loginScreen.auth0logout().then(() => {
          console.log("Clear state");
          this.apiService.lastBulkUpdateChecksums = null;
          this.state = this.emptyState(this.state.installId);

          this.setApiUser();
          this.saveState().then(() => {
            console.log("Saved empty state");
            console.log(this.state.currentUser);
            if (this.updateState != null) this.updateState();
            navigate(this, "welcome", null, null);
          });
        });
    }
  }

  getUIVersion(page) {
    //hack for v1/v2, to refactor after fully transitioned to v2 for proper support of themes (per page, selected from srv)
    const version =
      this.state.uiVersion != null
        ? this.state.uiVersion
        : APPCONFIG.DEFAULT_THEME;
    console.log("Page " + page + ", default version " + version);
    return version;
  }

  registerRefresh(refreshCallback) {
    this.registeredCurrentPageRefresh = refreshCallback;
  }

  currentPageRefresh() {
    if (this.registeredCurrentPageRefresh != null) {
      var now = +new Date();
      if (now - this.lastActivateRefresh > THROTTLE_ACTIVATE_REFRESH_MS) {
        this.lastActivateRefresh = now;
        this.registeredCurrentPageRefresh();
      }
    }
  }

  getRNPage(page) {
    //TODO: remove temp hack for sets_reflection version after full migration
    const rnReplacement = RN_PAGES[page];
    if (
      rnReplacement != "sets_reflection" ||
      (this.state.settings != null &&
        this.state.settings.reflection_version == 2)
    ) {
      return rnReplacement;
    } else {
      return null;
    }
  }

  navigate = (selectedPage, params = {}, isFromHome ) => {
    if (Utils.isPageWithFooter(selectedPage)) {
      if (isFromHome) {
        this.navigation?.jumpTo(selectedPage, params);
      } else {
        this.navigation?.navigate("mana", { selectedPage, params });
      }
    } else if (this.state.currentUser) {
      //this.changePage("feed", { selectedPage, args: params });
      this.navigation?.navigate(selectedPage, params);
    } else {
      this.changePage("welcome", { selectedPage, args: params });
    }
  };

  changePage(page, args) {
    this.registeredCurrentPageRefresh = null;

    /* if (!this.hasAcceptedTerms()) {
      return this.navigation.navigate("onboarding_info");
    } */

    if (this.getUIVersion(page) === "v2") {
      const rnReplacement =
        args != null && args.selectedPage != null
          ? args.selectedPage.startsWith("rn:")
            ? args.selectedPage
            : this.getRNPage(args.selectedPage)
          : null;
      if (rnReplacement != null)
        page = (rnReplacement.startsWith("rn:") ? "" : "rn:") + rnReplacement;
      else if (args != null && args.selectedPage != null)
        page = args.selectedPage;
    }

    if (page != null && page.startsWith("rn:")) {
      const targetPage = page.substring(3);
      this.changePageSvg(targetPage, {
        selectedPage: page,
        args: args,
        lastScrollTop: this.lastScrollTop,
      });
    } else {
      this.changePageSvg(page, args);
    }
  }

  hasNavigation() {
    //TODO: enable navigation by default before login
    return APPCONFIG.USE_NAVIGATION;
    //&& (this.state?.settings?.testing_preferences == null ||
    //    this.state?.settings?.testing_preferences?.navigation_refactor);
  }

  changePageSvg(page, args) {
    //TODO: drop this function when v2 migration is finished, use clear and simple routing
    const extraData = {};

    if (page == null) page = "feed";
    if (
      args != null &&
      args.selectedPage != null &&
      args.selectedPage.startsWith("rn:")
    ) {
      page = args.selectedPage.substring(3);
    }

    if (
      this.state.selectedPage === "welcome" &&
      page === "onboarding" &&
      this.state.currentUser != null
    ) {
      page = "home_card";
    }

    const strArgs = args != null ? JSON.stringify(args) : "";
    console.log(
      "-> Changing page to " +
        page +
        " from " +
        this.state.selectedPage +
        " to " +
        (args != null ? args.selectedPage : "null") +
        " " +
        (strArgs && strArgs.length > 100 ? strArgs.substring(0, 100) : strArgs),
    );

    if (this.hasNavigation() && this.navigation != null) {
      try {
        let target = page ? NAVIGATION_MAPPING[page] : "home";

        const termsAgreed = this.hasAcceptedTerms();

        if (
          this.state.settings != null &&
          APPCONFIG.USE_NAVIGATION &&
          (this.state.impersonate == null ||
            this.state.impersonate == this.state.currentUser) &&
          !termsAgreed &&
          !["login", "welcome", "error"].includes(target)
        ) {
          target = appPages.onboardingInfoPage;
        }

        let dest = target || page;

        if (
          dest === appPages.onboardingInfoPage &&
          this.state.impersonate != null &&
          this.state.impersonate != this.state.currentUser
        ) {
          dest = "feed";
        }

        console.log("> Navigate " + dest);
        if (dest === "feed") {
          //temp hack
          this.navigation.navigate("feed");
          this.navigation.navigate("mana", { Screen: "feed" });
        } else {
          this.navigation.navigate(dest, args?.args);
        }
        return;
      } catch (e) {
        console.log(e)
        //continue
      }

      console.log("Fallback to page change");
    }

    if (
      page !== this.state.currentScreen ||
      (args != null &&
        args.selectedPage !== this.state.selectedPage &&
        args.selectedPage != null)
    ) {
      if (this.onPageChange != null) {
        this.onPageChange();
      }
      Object.assign(extraData, {
        error: null,
        error_element: null,
        selectedPage:
          args != null
            ? args.selectedPage
            : page === "feed"
            ? this.state.selectedPage
            : "home_card",
      });
    }

    //TODO: cleanup and simplify all this scrolling. should have a clear history with state transitions
    if (args != null && args.args != null && args.args.backScrollTop != null) {
      args.lastScrollTop = args.args.backScrollTop;
      args.backScrollTop = undefined;
    }

    const { argsHistory, history } = this.addPageHistory(page, args);

    this.updatePageInState(page, args, history, argsHistory, extraData);
  }

  updatePageInState(page, args, history, argsHistory, extraState = {}) {
    const pupdate = {
      prevScreen: this.state.currentScreen,
      currentScreen: page,
      screenArgs: args,
      selectedPage: this.state.selectedPage,
      pageHistory: history,
      pageArgsHistory: argsHistory,
      ...extraState,
    };

    if (args != null && args.selectedPage != null) {
      pupdate.selectedPage = args.selectedPage;
    }

    // Sets the new state
    this.setState(pupdate);
  }

  addPageHistory(page, args) {
    const len =
      this.state.pageHistory != null ? this.state.pageHistory.length : 0;
    const hasPages = len > 0;
    const isNewPage = hasPages
      ? this.state.pageHistory[len - 1] === page
      : false;
    const argsHistory = hasPages
      ? isNewPage
        ? this.state.pageArgsHistory
        : this.state.pageArgsHistory.concat([args])
      : [args];
    const history = hasPages
      ? isNewPage
        ? this.state.pageHistory
        : this.state.pageHistory.concat([page])
      : [page];

    return { argsHistory, history };
  }

  removePageFromHistory() {
    const len =
      this.state.pageHistory != null ? this.state.pageHistory.length : 0;
    const hasPages = len > 1;
    const page = hasPages ? this.state.pageHistory[len - 2] : null;
    const args = hasPages ? this.state.pageArgsHistory[len - 2] : null;
    const argsHistory = hasPages
      ? this.state.pageArgsHistory.slice(0, len - 2)
      : [];
    const history = hasPages ? this.state.pageHistory.slice(0, len - 1) : [];
    return { page, args, argsHistory, history };
  }

  goBack() {
    if (this.hasNavigation() && this.navigation != null) {
      this.navigation.goBack();
    } else {
      const { page, args, argsHistory, history } = this.removePageFromHistory();

      if (page != null && page !== this.state.currentScreen) {
        this.updatePageInState(page, args, history, argsHistory);
      } else {
        this.changePage("rn:home_card");
      }
    }
  }

  getReturnUrl = () => {
    this.state.pageHistory.pop(); // skip current page
    return this.state.pageHistory.pop() || "rn:home_card";
  };

  setState(params) {
    if (this.state.error !== null) {
      if (
        (params.currentScreen != null &&
          params.currentScreen !== this.state.currentScreen) ||
        (params.selectedPage != null &&
          params.selectedPage !== this.state.selectedPage)
      ) {
        params.error = null;
        params.error_element = null;
      }
    }

    this.state = Object.assign({}, this.state, params);

    this.saveState().then(() => {
      if (this.updateState != null) this.updateState();
      console.log("Saved state.");
    });
  }

  getState() {
    return this.state;
  }

  startAction(action) {
    var d = +new Date();
    var s = this.pendingActionStart;

    if (
      this.pendingAction != null &&
      s != null &&
      d - s < this.retryActionEvenIfPendingMs
    ) {
      //console.log("Skipping action " + action + ", action " + this.pendingAction + " already in progress.");
      return false;
    } else {
      //console.log("Starting action " + action);
      this.pendingAction = action;
      this.pendingActionStart = d;
      this.actionStartLog[action] = d;
      return true;
    }
  }

  endAction(action) {
    if (this.pendingAction != null) {
      console.log("Ending action " + action);
      this.pendingAction = null;
      var d = +new Date();
      var s = this.actionStartLog[action];
      if (s != null) {
        this.actionLog.push({ action: action, time: d - s });
        this.actionStartLog[action] = null;
      }
    }
  }

  getItems(redirectScreen, redirectPage, redirectArgs) {
    this.getItemsBulk(null, redirectScreen, redirectPage, redirectArgs);
  }

  getItemsWithStats(redirectScreen, redirectPage, redirectArgs) {
    var stats = { action_log: this.actionLog };
    this.actionStartLog = {};
    this.actionLog = [];
    this.getItemsBulk(stats, redirectScreen, redirectPage, redirectArgs);
  }

  actOffline() {
    var now = +new Date();
    return (
      this.offlineEnabled &&
      this.apiService.isOffline &&
      (now - this.lastOnlineRetry < this.retryOnlineIntervalMs ||
        this.lastActionsCount < this.retryActionsCount)
    );
  }

  getHour(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + " " + ampm;
  }

  getMinutes(hmsz) {
    var it1 = hmsz.split(" ");
    var it2 = it1[0].split(":");
    var isPM = it1[1].toLowerCase() === "pm";
    return (
      ((isPM ? 12 : 0) + (it2[0] % 12 ? 0 : -12) + 1 * it2[0]) * 60 + 1 * it2[1]
    );
  }

  queueOfflineAction(action) {
    if (this.state.offlineActions == null) {
      this.state.offlineActions = [action];
    } else {
      this.state.offlineActions.push(action);
    }
  }

  //TODO: move offline actions to separate class. Need to be revisited
  cardActionOffline(action) {
    console.log(
      "Cached offline actions: " +
        (this.state.offlineActions != null
          ? this.state.offlineActions.length
          : 0),
    );
    console.log("Caching offline action " + JSON.stringify(action));
  }

  confirmMoreOffline(itemKey) {
    //REMOVED
  }

  mergeUploadData(uploadData) {
    if (uploadData != null) {
      if (this.state.uploadData == null) {
        this.state.uploadData = [uploadData];
      } else {
        this.state.uploadData.push(uploadData);
      }
    }
  }

  updateEmbeddedSettings() {
    const { testing_preferences } = this.state?.settings || {};
    if (testing_preferences && isWeb) {
      NativeHelper.sendFlagsToApp(testing_preferences);
    }
  }

  getApiData(datatype = "timeslots", args = {}, callback = () => {}) {
    //if (!this.startAction("apiService.getApiData")) return; //commented, we allow multiple calls in parallel
    const { calendarItems, healthItems } = this.getIntegrationData();

    console.log("Get data for " + datatype);
    let avatar = this.state.impersonate == null ? this.state.picture : null;
    if (avatar === this.lastUploadedAvatar) avatar = null;
    else this.lastUploadedAvatar = avatar;

    if (this.apiService.user == null) this.setApiUser();
    this.apiService
      .retrieveBulkUpdates(
        [
          {
            page_args: args,
            avatar: avatar ? avatar : undefined,
          },
        ],
        this.state.offlineActions,
        calendarItems,
        healthItems,
        this.state.selectedPage,
        this.cachedReferences,
      )
      .then((response) => {
        //this.endAction("apiService.getApiData");
        if (response == null) {
          if (this.offlineEnabled && this.apiService.isOffline) {
            return;
          } else {
            this.changePage("offline");
          }
        } else if (
          response.error != null &&
          response.error === "Invalid credentials"
        ) {
          this.logout();
        } else if (response.error != null && response.error === "Unauthorized") {
          this.changePage("error", {
            message: "Not authorized. Please contact us to enable your account",
          });
        } else if (
          response.confirmNonce != null &&
          response.confirmNonce < this.apiService.confirmNonce
        ) {
          this.updateStateFromReply(recvData, null, null, false);
          console.log("Ignoring outdated reply, waiting another refresh...");
        } else {
          this.updateStateFromReply(response, null, null, true);
          const reply = this.__formatCacheableData(response, datatype);

          // Update state
          this.setState({
            [datatype]: reply,
          });

          console.log("Finished get data for " + datatype);
          if (callback) callback(reply);
        }
      })
      .catch((err) => {
        //this.endAction("apiService.getApiData");
        //TODO: log
      });
  }

  __formatCacheableData = (response, datatype) => {
    let reply = response[datatype] || this.state[datatype];

    const data =
      ["reflection"].includes(datatype) && this.state.impersonate
        ? {
            user: this.state.impersonate,
            ...reply,
          }
        : reply;

    return data;
  };

  setApiUser() {
    const { currentUser, accessToken, installId, impersonate } = this.state;
    this.apiService.setUser(currentUser, accessToken, installId);
    this.apiService.setImpersonate(impersonate);
  }

  getItemsBulk(uploadData, redirectScreen, redirectPage, redirectArgs) {
    this.mergeUploadData(uploadData);

    if (this.actOffline()) {
      //act on existing data
      this.redirect(redirectScreen, redirectPage, redirectArgs);
      return;
    } else {
      this.lastOnlineRetry = +new Date();
    }

    if (this.state.currentUser != null) {
      if (!this.startAction("apiService.retrieveBulkUpdates")) return;

      const selectedPage = this.state.selectedPage;
      const { calendarItems, healthItems } = this.getIntegrationData();

      if (this.apiService.user == null) this.setApiUser();
      this.apiService
        .retrieveBulkUpdates(
          this.state.uploadData,
          this.state.offlineActions,
          calendarItems,
          healthItems,
          selectedPage,
          this.cachedReferences,
        )
        .then((recvData) => {
          //console.log(JSON.stringify(recvData));
          this.endAction("apiService.retrieveBulkUpdates");
          if (recvData == null) {
            if (this.offlineEnabled && this.apiService.isOffline) {
              console.log("Switching to offline mode");
              return; //do nothing, act on existing data
            } else {
              this.changePage("offline");
            }
          } else if (
              recvData.error != null &&
              recvData.error === "Invalid credentials"
          ) {
            this.logout();
          } else if (
            recvData.error != null &&
            recvData.error === "Unauthorized"
          ) {
            this.changePage("error", {
              message:
                "Not authorized. Please contact us to enable your account",
            });
          } else if (
            recvData.confirmNonce != null &&
            recvData.confirmNonce < this.apiService.confirmNonce
          ) {
            this.updateStateFromReply(recvData, screenArgs, selectedPage, false);
            console.log("Ignoring outdated reply, waiting another refresh...");
          } else {
            this.state.uploadData = null;
            this.state.offlineActions = null;

            const screenArgs = {
              lastScrollTop:
                redirectArgs != null && redirectArgs.lastScrollTop != null
                  ? redirectArgs.lastScrollTop
                  : 0,
            };
            const selectedPage = redirectPage != null ? redirectPage : "home";
            this.updateStateFromReply(recvData, screenArgs, selectedPage, true);

            const hasNavigation =
              APPCONFIG.USE_NAVIGATION && this.hasNavigation();
            let allowRedirect =
              redirectScreen != null || redirectPage != null || !hasNavigation;

            if (
              APPCONFIG.USE_NAVIGATION &&
              !this.hasAcceptedTerms() &&
              !["login", "welcome", "error"].includes(redirectScreen)
            ) {
              redirectScreen = appPages.onboardingInfoPage;
              allowRedirect = true;
            }

            if (allowRedirect) {
              if (
                redirectScreen == null &&
                redirectPage != null &&
                !redirectPage.startsWith("rn:")
              ) {
                //to remove after full transition to v2
                redirectScreen = "feed";
              }

              if (
                redirectScreen == null &&
                redirectPage == null &&
                this.state.currentScreen === "offline"
              ) {
                redirectScreen = "feed";
                redirectPage = "home";
              }

              console.log(
                "Redirect page: " + redirectScreen + " " + redirectPage,
              );
              console.log("Redirect args: " + JSON.stringify(redirectArgs));
              this.redirect(redirectScreen, redirectPage, redirectArgs);
            } else {
              this.currentPageRefresh();
            }
          }
        })
        .catch((err) => {
          this.endAction("apiService.retrieveBulkUpdates");
          console.log("Error: " + err);
        });
    }
  }

  addPredictionNames(timeslots, activities) {
    if (activities) {
      const elements = {};
      activities.forEach((a) => {
        elements[a.id] = a;
      });

      timeslots.forEach((t) => {
        if (t && t.predicted_activities) {
          t.predicted_activities.forEach((p) => {
            const element = elements[p.id];
            if (element) {
              p.name = element.name;
              p.icon = element.icon;
            }
          })
        }
      });
    }
  }

  getIntegrationData() {
    const calendarItems =
      !APPCONFIG.GOOGLE_CLIENT_OFFLINE && (this.lastCalendarItemsChecksum == null || this.lastCalendarItemsChecksum != this.state.calendarItemsChecksum)
        ? this.state.calendarItems
        : null;
    this.lastCalendarItemsChecksum = this.state.calendarItemsChecksum;
    //console.log("Sending calendar " + JSON.stringify(calendarItems));

    const healthItems =
      this.lastHealthItemsChecksum == null || this.lastHealthItemsChecksum != this.state.healthItemsChecksum
        ? this.state.healthItems
        : null;
    this.lastHealthItemsChecksum = this.state.healthItemsChecksum;
    //console.log("Sending health " + JSON.stringify(healthItems));
    return { calendarItems, healthItems };
  }

  getIntegrationRules = () => {
    const action = {
      action: "get-rules",
    };

    return new Promise((resolve, reject) => {
      this.apiService.cardAction(action).then(
        (rules) => {
          // Update controller state
          this.setState({rules});
          resolve(rules);
        },
        (error) => {
          reject(error);
        },
      );
    });
  };

  updateStateFromReply(recvData, screenArgs, selectedPage, applyToTimeslots) {
    this.lastOnline = +new Date();
    var cards = recvData.cards;
    var cardsTemplates = recvData.cardsTemplates;
    var svgTemplates = recvData.svgTemplates;
    var cardsVariables = recvData.cardsVariables;
    var users = recvData.users;
    var lastManaTime = recvData.last_mana_time;
    var settings = recvData.settings;
    var stats = recvData.stats;
    var uiVersion = recvData.uiVersion;

    this.replaceCachedVars(cardsVariables);
    this.updateVersion(recvData);

    const newState = {
      rec_ui_ver: recvData.rec_ui_ver || this.state.rec_ui_ver,
      cards: cards || this.state.cards,
      cardsVariables: cardsVariables || this.state.cardsVariables,
      cardsTemplates: cardsTemplates || this.state.cardsTemplates,
      svgTemplates: svgTemplates || this.state.svgTemplates,
      users: users || this.state.users,
      selectedPage: selectedPage || this.state.selectedPage,
      screenArgs: screenArgs || this.state.screenArgs,
      uiVersion: uiVersion != null ? uiVersion : APPCONFIG.DEFAULT_THEME,
      lastUpdateTime: +new Date(),
      lastManaTime: lastManaTime,
      settings: settings || this.state.settings,
      stats: stats || this.state.stats,
      activities: recvData.elements || this.state.elements,
      //activities: recvData.activities || this.state.activities,
      //tags: recvData.tags || this.state.tags,
      //sets: recvData.sets || this.state.sets,
      elements: recvData.elements || this.state.elements,
      archived_elements: recvData.archived_elements || this.state.archived_elements,
      goal_presets: recvData.goal_presets || this.state.goal_presets,
      sequences: recvData.sequences || this.state.sequences,
      probable_times: recvData.probable_times || this.state.probable_times,
      calendar_prob: recvData.calendar_prob || this.state.calendar_prob,
      rules: recvData.rules || this.state.rules,
      reflection: recvData.reflection || this.state.reflection,
      reflection_insights: recvData.reflection_insights,
      resolution: recvData.resolution || this.state.resolution,
      reflection_root: recvData.reflection_root || this.state.reflection_root,
      sent_reports: recvData.sent_reports || this.state.sent_reports,
      received_reports:
          recvData.received_reports || this.state.received_reports,
      received_aggregated_reports:
          recvData.received_aggregated_reports || this.state.received_aggregated_reports,
      teams: recvData.teams || this.state.teams,
      snoozed_cards: recvData.snoozed_cards || this.state.snoozed_cards,
      routines: recvData.routines || this.state.routines,
      template_data: recvData.template_data || this.state.template_data,
      cards_v2: recvData.cards_v2 || this.state.cards_v2,
    };

    if (this.state) Object.keys(this.state).forEach((k) => {
      if (k.startsWith("timeslots_data")) {
        newState[k] = this.state[k];
      }
    });
    if (recvData) Object.keys(recvData).forEach((k) => {
      if (k.startsWith("timeslots_data")) {
        newState[k] = recvData[k];
      }
    });

    if (applyToTimeslots) {
      newState.timeslots = [];
      const keys = Object.keys(newState);
      keys.sort();
      keys.forEach((k) => {
        if (k.startsWith("timeslots_data")) {
          const d = newState[k];
          if (d) newState.timeslots.push(...d);
        }
      });
      if (newState.timeslots) {
        this.addPredictionNames(newState.timeslots, recvData.elements || this.state.elements);
      }
    }

    if (recvData.checksums != null) {
      Object.keys(recvData.checksums).forEach((k) => {
        if (!newState[k]) recvData.checksums[k] = undefined;
      })
      this.apiService.lastBulkUpdateChecksums = recvData.checksums;
    }

    this.setState(newState);

    this.applyUserSettings();
  }

  updateVersion(recvData) {
    if (this.state.rec_ui_ver && recvData.rec_ui_ver && (isWeb || window.embeddedLogin)) {
      const controller = this;
      if (recvData.rec_ui_ver > APPCONFIG.DISPLAY_VERSION) {
        Storage.getItem("last_app_refresh").then((data) => {
          var now = +new Date();
          if (controller.lastReloadTimeMs == null) controller.lastReloadTimeMs = data;
          const deltaTime = controller.lastReloadTimeMs ? Math.round((now - controller.lastReloadTimeMs) / 1000) : null;
          if (deltaTime == null || deltaTime > 2 * 3600) {
            controller.lastReloadTimeMs = now;
            console.log("Trying to update from " + APPCONFIG.DISPLAY_VERSION + " to " + recvData.rec_ui_ver + (deltaTime ? ", last retry " + deltaTime + "sec ago" : ""));
            Storage.setItem("last_app_refresh", now).then((reply) => {
              if (window.embeddedLogin && window.embeddedLogin.triggerCodeUpdate) {
                window.embeddedLogin.triggerCodeUpdate();
              } else if (isWeb) {
                window.location.reload(true);
              }
            });
          }
        });
      }
    }
  }

  replaceCachedVars(cardsVariables) {
    if (cardsVariables != null) {
      cardsVariables.forEach((c) => {
        const checksums = c[":checksums:"];
        if (checksums != null) {
          const chk = JSON.parse(checksums);
          Object.keys(chk).forEach((k) => {
            const checksum = chk[k];
            const val = c[k];
            if (!val.startsWith("cached:")) {
              const key = c.card_type + "|" + k + "|" + checksum;
              const oldKey = this.cachedReferences[c.card_type + "|" + k];
              if (oldKey != null) this.cachedVariables[oldKey] = undefined;
              this.cachedVariables[key] = val;
              this.cachedReferences[c.card_type + "|" + k] = checksum;
            }
          });
        }

        Object.keys(c).forEach((k) => {
          const val = c[k];
          if (val.startsWith("cached:")) {
            const key = val.substring("cached:".length);
            const cachedVal = this.cachedVariables[key];
            if (cachedVal != null) {
              c[k] = cachedVal;
            }
          }
        });
      });
    }
  }

  redirect(screen, page, redirectArgs) {
    const currentPage =
      screen != null || page != null ? page : this.state.currentScreen;
    if (
      (screen == null || screen === "feed") &&
      this.getUIVersion(currentPage) === "v2" &&
      this.getRNPage(currentPage) != null
    ) {
      this.changePage(this.getRNPage(currentPage), redirectArgs);
    } else if (page != null && page.startsWith("rn:")) {
      this.changePage(page, redirectArgs);
    } else if (
      (screen != null &&
        !this.isTransient.includes(screen) &&
        this.definedPages.includes(screen)) ||
      this.state.currentScreen == null ||
      this.isTransient.includes(this.state.currentScreen) ||
      !this.definedPages.includes(this.state.currentScreen)
    ) {
      this.changePage(screen, redirectArgs);
    }
  }

  cardAction(action) {
    const that = this;
    if (action.requestPage != null) {
      console.log("Card action request");
      this.cardActionWithCallback(action, function (action) {
        const screen = "feed";
        const page = action.requestPage;
        const args = action.requestArgs;

        var requestAction = {};
        requestAction["action"] = "requestpage";
        requestAction["page"] = page;
        requestAction["page_args"] = args;
        that.getItemsBulk(requestAction, screen, page, {
          lastScrollTop: this.lastScrollTop,
        });
      });
    } else {
      console.log("Card action");
      this.cardActionWithCallback(action, function (action) {
        that.getItems(
          action.redirectScreen,
          action.redirectPage,
          action.redirectArgs,
        );
      });
    }
  }

  /**
   * Offline mode
   * Selects and optimistically confirms the slot, while scheduling
   * a bulk update in the background
   * @param {Object} action Action model
   * @returns {Bool} flag if action was performed instantly in current state
   */
  handleActionAndRetrieveUpdate(action) {
    //return false; //temp disable

    if (action.action !== "next" && action.action !== "undo") {
      //we only know to handle slot confirmations offline
      return false;
    }

    this.apiService.increaseConfirmNonce();

    const currentState = this.state;
    if (currentState.timeslots == null) {
      console.log("Action not applied! No time slots");
      return;
    }
    const selected = currentState.timeslots.find(
      (slot) => action.id && (action.id + ",").indexOf(slot.id + ",") !== -1, //use , as sep to avoid matching substr ids
    );

    const matchedTimeSlots = []
    const alreadyAdded = [];
    currentState.timeslots.forEach(
      (slot) => {
        if (action.id && (action.id + ",").indexOf(slot?.id + ",") !== -1 && !alreadyAdded.includes(slot?.id)) {
          matchedTimeSlots.push(slot);
          alreadyAdded.push(slot?.id);
        }
      },
    );
    const selectedIndex = currentState.timeslots.indexOf(selected);

    // If we can not find the timeslot, return the false flag
    if (!selected) {
      return false;
    }

    if (action.end_time != null) {
      let delta = moment
        .duration(moment(action.end_time).diff(moment(selected.time)))
        .asMinutes();
      if (
        delta != selected.duration ||
        action.extend_interval === -1 ||
        action.extend_interval_start === -1
      ) {
        //different length timeslot, cannot be handled offline right now. We'll need to change the flow here
        console.log("Different length timeslot");
        return false;
      }
    }

    switch (true) {
      // Mutate in place the `timeslots` and patch the selected slot with the action
      case action.action === "next" &&
        action.type !== "-" &&
        action.type !== "undo": {
        selected.undo_activity = "undo";

        // Make sure the duration matches
        //selected.duration = matchedTimeSlots.length * this.state.settings.interval_duration;
        selected.duration = 0;
        matchedTimeSlots.forEach(
          (t) =>
            (selected.duration +=
              t.duration != null && t.duration > 0
                ? t.duration
                : this.state.settings.interval_duration),
        );

        // Define the activity
        selected.activity = {
          ...selected.activity,
          id: action.type,
          ...action.activity_details,
          ...action.activity,
        };

        delete action.activity_details;

        selected.confirmed = true;
        selected.auto_fill = 0;

        // If this is the predication case handle it
        if (selected.predicted_activities) {
          const predictedActivity = selected.predicted_activities.find(
            (item) => item.id === action.type,
          );

          // If we have our predicted activity in here
          // assign the properties to it
          if (predictedActivity) {
            Object.assign(selected.activity, predictedActivity);
          }

          // Keep a copy of the predicted activities to be able to restore them at undo
          selected.initial_predicted_activites = selected.predicted_activities;

          // Remove the predicted activities properties
          delete selected.predicted_activities;
        }

        if (matchedTimeSlots.length > 1) {
          // Remove the leftovers
          currentState.timeslots.splice(
            // Starting from the `next` index
            selectedIndex + 1,
            // Remove the total matched ids, without the `head`
            matchedTimeSlots.length - 1,
          );
        }

        console.log("Local timeslot filled");
        currentState.timeslots_local_update_time = new Date().getTime();
        return true;
      }

      // If the action is either `-` or `undo`
      case ["-", "undo"].indexOf(action.action) !== -1:
      // or we're dealing with a `next` but with action.type undo
      case action.action === "next" &&
        (action.type === "-" || action.type === "undo"): {
        if (selected.id !== action.id) {
          //find the most recent updated chunks and undo them
          const ids = action.id.split(",");
          const ts = [];
          ids.forEach((id) => {
            const selected = currentState.timeslots.find(
              (slot) => (id + ",").indexOf(slot.id + ",") !== -1,
            );
            if (selected) ts.push(selected);
          });

          ts.sort((a, b) =>
            a.last_updated > b.last_updated
              ? 1
              : b.last_updated > a.last_updated
              ? -1
              : 0,
          );

          const chunkId = ts.length > 0 ? ts[ts.length - 1].id_chunk : null;
          const toUndo = ts
            .filter((t) => t.id_chunk === chunkId)
            .map((t) => t.id);
          toUndo.forEach((id) => this.undoTimeSlot(currentState, id));

          currentState.timeslots_local_update_time = new Date().getTime();
          return true;
        } else {
          this.undoTimeSlot(currentState, selected.id);
        }

        console.log("Local timeslot undo");
        return true;
      }
    }

    return false;
  }

  undoTimeSlot(currentState, timeslotId) {
    if (currentState.timeslots == null) {
      console.log("Undo not applied! No time slots");
      return;
    }
    const selected = currentState.timeslots.find(
      (slot) => (timeslotId + ",").indexOf(slot.id + ",") !== -1, //use , as sep to avoid matching substr ids
    );
    const selectedIndex = currentState.timeslots.indexOf(selected);
    if (
      selected.undo_activity != null &&
      selected.undo_activity !== "-" &&
      selected.undo_activity != "undo"
    ) {
      selected.id_activity = selected.undo_activity;
    } else {
      // Copy over the predicted activities
      selected.predicted_activities =
        // Either from the in memory pointer
        selected.initial_predicted_activites ||
        // Or from the next ones
        getPredictedActivitiesFromIndex(currentState.timeslots, selectedIndex);

      // Cleanup the model
      if (selected.initial_predicted_activites) {
        delete selected.initial_predicted_activites;
      }

      // Remove the activtiy
      delete selected.activity;
      selected.confirmed = false;
    }
  }

  cardActionWithCallback(action, onRemoteCalled, onError, refreshFromRemote = true) {
    if (action.action === "refresh") {
      if (onRemoteCalled) onRemoteCalled();
      return;
    }

    this.cardActionCount++;
    this.lastActionsCount++;
    if (this.state.screenArgs != null && this.state.screenArgs.args != null) {
      this.state.screenArgs.args.overrides = null;
    }

    if (this.actOffline()) {
      this.cardActionOffline(action);
      return;
    } else {
      this.lastActionsCount = 0;
      this.lastOnlineRetry = +new Date();
    }

    const actName = "apiService.cardAction " + this.lastActionsCount;
    this.startAction(actName);

    // Mutate in place the state
    const performedLocally = this.handleActionAndRetrieveUpdate(action);
    if (performedLocally) {
      //eager signal of action done
      console.log(new Date().toISOString() + " Performed on local state " + JSON.stringify(action));
      setTimeout(() => {
        this.performRemoteAction(action, actName, onError, performedLocally, onRemoteCalled, refreshFromRemote);
      }, 0);
      onRemoteCalled(action, { status: "ok", local: true });
    } else {
      this.performRemoteAction(action, actName, onError, performedLocally, onRemoteCalled, refreshFromRemote);
    }
  }

  performRemoteAction(action, actName, onError, performedLocally, onRemoteCalled, refreshFromRemote = true) {
    const cardActionCountOnRequest = this.cardActionCount;

    if (this.apiService.user == null) this.setApiUser();
    this.apiService
        .cardAction(action, this.state.offlineActions)
        .then((recvData) => {
          console.log(recvData);
          this.endAction(actName);
          if (recvData == null) {
            if (this.offlineEnabled && this.apiService.isOffline) {
              console.log("Switching to offline mode");
              this.cardActionOffline(action);
            } else {
              this.changePage("offline");
            }
          } else {
            this.state.offlineActions = null;
            if (recvData.error != null) {
              this.setState({
                error: recvData.error,
                error_element: recvData.error_element,
              });
              console.log(this.state.screenArgs);
              if (typeof onError == "function") onError(recvData);

              // TODO: if user enters invalid data he gets redirected to home
              // this.changePage(this.state.currentScreen, this.state.screenArgs);
            } else {
              if (this.state.error != null) {
                this.setState({
                  error: null,
                  error_element: null,
                });
              }

              // Call the callback
              if (performedLocally) {
                if (false) { //no longer update from server on offline (assume offline mode has done things properly)

                } else {
                  //if action was done locally, trigger a full refresh from server
                  //TODO: throttle at a later date. if multiple actions are done in a sequence, only one refresh is needed
                  console.log("Full time slots refresh after local action");
                  setTimeout(() => {
                    if (cardActionCountOnRequest < this.cardActionCount) {
                      //do nothing, there will be another newer refresh
                      console.log(
                          "Refresh for " +
                          cardActionCountOnRequest +
                          " delayed, " +
                          this.cardActionCount +
                          " in progress",
                      );
                    } else {
                      console.log("Refresh after action");
                      this.trackConfirmTriggered = null;
                      this.refreshInBackground(cardActionCountOnRequest, null);
                    }
                  }, cardActionCountOnRequest < this.cardActionCount ? THROTTLE_BACKGROUND_REFRESH_MS : 150);
                }
              } else {
                //signal action done
                recvData.local = false;
                if (refreshFromRemote) {
                  console.log("Refresh after action, callback");
                  this.refreshInBackground(cardActionCountOnRequest, () => onRemoteCalled(action, recvData));
                } else {
                  onRemoteCalled(action, recvData);
                }
              }
            }
          }
        })
        .catch((err) => {
          this.endAction(actName);
          console.log("Error: " + err);
        });
  }

  refreshInBackground(cardActionCountOnRequest, onRefreshCallback) {
    if (this.state.currentUser == null) return;

    getStorageItem(getStorageKey(this, "CONFIRMATION_DATE")).then(
      (savedDateTime) => {
        console.log("Refresh in background");
        const refreshArgs =
          savedDateTime != null ? { timeslotsDate: savedDateTime } : null;
        this.getApiData("timeslots", refreshArgs, (timeslots) => {
          if (cardActionCountOnRequest == this.cardActionCount) {
            const oldTimeslots = this.state.timeslots;
            if (
              this.lastBackgroundRefresh == null ||
              new Date().getTime() - this.lastBackgroundRefresh >
                24 * 60 * 1000 ||
              !timeslotsEqual(oldTimeslots, timeslots, savedDateTime)
            ) {
              console.log("Timeslots changed");
              this.lastBackgroundRefresh = new Date().getTime();
              //update on the last refresh
              this.setState((state) => ({
                ...state,
                timeslots: timeslots,
              }));
              //onRemoteCalled(action, recvData); //no longer needed, already done on eager reply
              this.currentPageRefresh();
            } else {
              console.log("Timeslots identical");
              //this.currentPageRefresh();
            }

            if (onRefreshCallback != null) {
              onRefreshCallback();
            }
          } else {
            console.log(
              "Refresh for " +
                cardActionCountOnRequest +
                " not applied, " +
                this.cardActionCount +
                " in progress",
            );
          }
        });
      },
    );
  }

  confirmMore(itemKey) {
    if (this.actOffline()) {
      this.confirmMoreOffline(itemKey);
      return;
    } else {
      this.lastOnlineRetry = +new Date();
    }

    if (!this.startAction("apiService.getItem")) return;
    if (this.apiService.user == null) this.setApiUser();
    this.apiService
      .getItem(itemKey)
      .then((item) => {
        this.endAction("apiService.getItem");
        if (item == null) {
          if (this.offlineEnabled && this.apiService.isOffline) {
            console.log("Switching to offline mode");
            this.confirmMoreOffline(action);
          } else {
            this.changePage("offline");
          }
        } else {
          this.setState({ selectedItem: item });
          this.changePage("confirm");
        }
      })
      .catch((err) => {
        this.endAction("apiService.confirmMore");
        console.log("Error: " + err);
      });
  }

  customSleep(hour, sleepTypeId) {
    this.changePage("sleep", { hour: hour, sleepTypeId: sleepTypeId });
  }

  editElement(item) {
    const action = { action: "element_edit", id: item.Id.toString() };
    console.log(action);
    this.tracking.track("Edit Element");
    this.cardAction(action);
  }

  initTutorials = () => {
    setTimeout(() => {
      this.toggleTutorialsMode();
    }, 100);
  };

  toggleTutorialsMode = (model) => {
    this.setState({ showTutorials: model, focusedTab: "" });
  };

  getDevices = (type) => {
    if (type === "calendar") {
      const gcal = this.state.settings && this.state.settings.devices ? this.state.settings.devices["google_calendar"] || [] : [];
      const mobile = []; //this.state.settings && this.state.settings.devices ? this.state.settings.devices["mobile_calendar"] || [] : [];
      return gcal.concat(mobile);
    } else if (type === "health") {
      const appleHealth = this.state.settings && this.state.settings.devices ? this.state.settings.devices["apple_health"] || [] : [];
      const gfit = []; //this.state.settings && this.state.settings.devices ? this.state.settings.devices["google_fit"] || [] : [];
      return appleHealth.concat(gfit);
    } else {
      return this.state.settings && this.state.settings.devices ? this.state.settings.devices[type] || [] : [];
    }
  };

  hasAcceptedTerms = () => {
    return (
      this.state.impersonate ||
      (this.state?.settings?.terms_agreed &&
        this.state?.settings?.country &&
        this.state?.settings?.nickname &&
        this.state.impersonate == null)
    );
  };
}

export default Controller;
